import './App.css';
import React from 'react';
import Contact from './Pages/Contact'
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import axios from 'axios';
import axiosRetry from "axios-retry";

// Axios全体にリトライルールを設定
axiosRetry(axios, {
  retries: 3, // 最大リトライ回数
  retryDelay: (retryCount) => retryCount * 1000, // 1秒、2秒、3秒と間隔を空ける
  retryCondition: (error) => {
    // ネットワークエラー、または GAS の 404 エラー時にリトライする

    console.log("Retrying request due to error:", error);

    return (
      axiosRetry.isNetworkOrIdempotentRequestError(error) ||
      error.response?.status === 404
    );
  },
});

function App() {

  return (
    <BrowserRouter>
        <Routes>
          <Route path={"/form/contact/"} element={<Contact/>}/>    
        </Routes>
    </BrowserRouter>
  );
}

export default App;
